import { onWindowLoad } from './app-mounted'

export function unSimpleHoverTimeout() {
  const wrappers = document.getElementsByClassName('un-dropdown');
  const timers = [];

  for (let i = 0; i < wrappers.length; i++) {
    (function setupDropdown(index) {
      const wrapper = wrappers[index];
      const dropdowns = wrapper.getElementsByClassName('un-dropdown__menu');

      if (0 === dropdowns.length) return;

      const dropdown = dropdowns[0];

      wrapper.addEventListener('mouseenter', () => {
        clearTimeout(timers[index]);
        dropdown.style.display = 'flex';
      });

      wrapper.addEventListener('mouseleave', () => {
        timers[index] = setTimeout(() => {
          dropdown.style.display = 'none';
        }, 300);
      });
    }(i));
  }
}

export function unAnchorScrollTo() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function scrollTo(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = 100;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = target.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    });
  });
}

export function activeFilterClass(
  parentSelector = '.js-cell-sidebar-stick-parent',
  targetSelector = '.js-cell-sidebar-stick',
  headerSelector = '#header-wrap',
  activeClass = 'active-sticky',
  headerActiveClass = 'active-filter',
  maxWidth = 5000
) {
  let lastScrollTop = 0;
  let isActive = false;

  function clearAllClasses() {
    const targetElement = document.querySelector(targetSelector);
    const headerElement = document.querySelector(headerSelector);

    if (targetElement && headerElement) {
      targetElement.classList.remove(activeClass, 'top', 'bottom');
      headerElement.classList.remove(headerActiveClass, 'top', 'bottom');
    }
    isActive = false;
  }

  function clearDirectionClasses() {
    const targetElement = document.querySelector(targetSelector);
    const headerElement = document.querySelector(headerSelector);

    if (targetElement && headerElement) {
      targetElement.classList.remove('top', 'bottom');
      headerElement.classList.remove('top', 'bottom');
    }
  }

  function activateClasses() {
    const targetElement = document.querySelector(targetSelector);
    const headerElement = document.querySelector(headerSelector);

    if (targetElement && headerElement) {
      targetElement.classList.add(activeClass);
      headerElement.classList.add(headerActiveClass);
    }
    isActive = true;
    clearDirectionClasses();
  }

  function handleScroll() {
    if (false !== maxWidth && window.innerWidth > maxWidth) {
      clearAllClasses();
      return;
    }

    const parentElement = document.querySelector(parentSelector);
    const targetElement = document.querySelector(targetSelector);
    const headerElement = document.querySelector(headerSelector);

    if (!parentElement || !targetElement || !headerElement) return;

    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const parentRect = parentElement.getBoundingClientRect();

    if (0 >= parentRect.top && !isActive) {
      activateClasses();
    } else if (0 < parentRect.top && isActive) {
      clearAllClasses();
    }

    if (isActive) {
      if (currentScrollTop > lastScrollTop) {
        targetElement.classList.add('bottom');
        targetElement.classList.remove('top');
        headerElement.classList.add('bottom');
        headerElement.classList.remove('top');
      } else {
        targetElement.classList.add('top');
        targetElement.classList.remove('bottom');
        headerElement.classList.add('top');
        headerElement.classList.remove('bottom');
      }
    }

    lastScrollTop = currentScrollTop;
  }

  clearAllClasses();

  window.addEventListener('scroll', handleScroll);

  onWindowLoad(clearAllClasses);

  window.addEventListener('resize', () => {
    if (false !== maxWidth && window.innerWidth > maxWidth) {
      clearAllClasses();
    }
  });
}
export function hiddenArrowsWhenNotEnoughLength() {
  function manageSliderArrows() {
    const arrowsElements = document.getElementsByClassName('js-hidden-arrows');
    for (let i = 0; i < arrowsElements.length; i++) {
      const element = arrowsElements[i];
      const dataCards = element.getAttribute('data-cards');
      if (dataCards) {
        const values = dataCards.split(',').map(val => parseInt(val.trim(), 10));
        if (4 === values.length) {
          const [mobileCards, tabletCards, desktopCards, totalCards] = values;
          const width = window.innerWidth;
          let currentCards;
          if (768 > width) {
            currentCards = mobileCards;
          } else if (1200 > width) {
            currentCards = tabletCards;
          } else {
            currentCards = desktopCards;
          }

          element.style.display = totalCards > currentCards ? '' : 'none';
        }
      }
    }
  }

  manageSliderArrows();
  window.addEventListener('resize', manageSliderArrows);
}
